import React, { forwardRef, useImperativeHandle } from 'react'
import CustomColumn from '../../../../../customControl/CustomColumn';
import { dateFormatWithTime, formatJsonDateToSQL, formatOnlyTimeToSQL, isBlank, onlyNumeric } from '../../../../commonClass/CommonValidation';
import { TimePicker } from 'antd';
import dayjs from 'dayjs';

const BookingCutOffSection = forwardRef(({ BookingCutOffForm, setBookingCutOffForm, dropdownData, formErrors, setFormErrors, disabled, setEditDisabled }, ref) => {

    const handleOnChange = (name, value) => {
        setEditDisabled(false);
        setFormErrors(null);
        setBookingCutOffForm((prev) => ({ ...prev, [name]: value }));
    }


    const ValidateBookingCutOffForm = () => {
        let error = {};

        if ([null]?.includes(BookingCutOffForm?.BookingCutoffDays)) {
            error.BookingCutoffDays = "Cannot leave blank, input is mandatory."
        }
        if (isBlank?.includes(BookingCutOffForm?.BookingCutoffTime)) {
            error.BookingCutoffTime = "Cannot leave blank, input is mandatory."
        }

        return error;
    }

    // Expose the childFunction to the parent's ref
    useImperativeHandle(ref, () => ({
        canValidate: true,
        ValidateBookingCutOffForm: ValidateBookingCutOffForm
    }));

    return (
        <>
            <div className="row">
                <CustomColumn labelText='Days' labelId='BookingCutoffDays' isRequired>
                    <div className="input-group">
                        <span className="input-group-text"> D - </span>
                        <input
                            type="text"
                            className='form-control'
                            name="BookingCutoffDays"
                            id="BookingCutoffDays"
                            placeholder='Days'
                            value={BookingCutOffForm?.BookingCutoffDays !== null ? BookingCutOffForm?.BookingCutoffDays : ""}
                            onChange={(e) => e.target.value?.length <= 1 && handleOnChange("BookingCutoffDays", onlyNumeric(e.target.value) ? Number(e.target.value) : null)}
                            disabled={disabled}
                            maxLength={1}
                        />
                    </div>
                    {formErrors?.BookingCutoffDays && <div className="text-danger text-start fs_14">{formErrors?.BookingCutoffDays}</div>}
                </CustomColumn>

                <CustomColumn labelText='Time' labelId='BookingCutoffTime' isRequired >
                    <TimePicker
                        className='form-control defo_border'
                        format='HH:mm:ss'
                        placeholder='HH:mm:ss'
                        id='BookingCutoffTime'
                        disabled={disabled}
                        value={BookingCutOffForm?.BookingCutoffTime ? dayjs(dateFormatWithTime(new Date(), BookingCutOffForm?.BookingCutoffTime)) : null}
                        onChange={(e) => handleOnChange('BookingCutoffTime', e?.$d ? formatOnlyTimeToSQL(e?.$d) : null)}
                    />
                    {formErrors?.BookingCutoffTime && <div className="text-danger text-start fs_14">{formErrors?.BookingCutoffTime}</div>}
                </CustomColumn>


            </div>
        </>
    )
});

export default BookingCutOffSection